import {Component, OnInit, signal, HostListener} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {DesktopComponent} from './features/desktop/desktop.component';
import {CommonModule} from '@angular/common';
import {LangService} from './core/services/lang.service';
import {ModalErrorHostComponent} from './shared/components/modal-error-host/modal-error-host.component';
import {HoomvipStorage} from './core/hoomvip-storage/hoomvip-storage.service';
import {ModalInfoHostComponent} from './shared/components/modal-info-host/modal-info-host.component';
import {ThemeService} from './core/services/theme.service';

declare const Weglot: any;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, DesktopComponent, CommonModule, ModalErrorHostComponent, ModalInfoHostComponent],
  templateUrl: './app.html'
})
export class App implements OnInit {
  isMobile = signal(this.detectMobile());

  constructor(
    private themeService: ThemeService,
    private langService: LangService,
    private hoomvipStorage: HoomvipStorage,
  ) {
  }

  @HostListener('window:resize')
  onResize() {
    this.isMobile.set(this.detectMobile());
  }

  private detectMobile(): boolean {
    const shouldDetect = this.hoomvipStorage?.shouldDetectMobile();
    const isSmallScreen = window.innerWidth <= 900;
    const isMobileUA = /Mobi|Android|iPhone|iPad|iPod/i.test(
      navigator.userAgent
    );
    return isSmallScreen || isMobileUA || shouldDetect === false;
  }

  ngOnInit(): void {
    this.themeService.detectAndApplyTheme();

    this.isMobile.set(this.detectMobile());

    const savedLang = this.langService.currentLang();
    if (!savedLang) {
      return;
    }

    const interval = setInterval(() => {
      const w = (window as any).Weglot;
      if (w && w.initialized) {
        w.switchTo(savedLang);
        clearInterval(interval);
      }
    }, 100);
  }
}
